import { Button, Checkbox, Col, Form, Input, Popconfirm, Row, Switch, Tooltip } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import React, { ReactElement, useEffect, useState } from 'react';
import Panel from '../../../../shared/components/card/Panel';
import {
  APPLICATION_ID,
  authFeatureConstants,
  DEFAULT_PAGE_SIZE, GUTTOR_SPACE, INVENTORY_MESSAGE_CONSTANTS, INVENTROY_CONSTANTS, PAGE_QUERY_PARAM, TOOLTIP_TEXT,
} from '../../../../shared/constants/commonConstants';
import { base64UrlDecode, base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl, formatPrice, GetFirstElement, success } from '../../../../utils/utility';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDayCareInclusionMaster } from '../../../../store/actions/hospitalAction';
import { FetchInPatientPackageRequest, FetchInPatientPackageResponse, SaveInPatientPackageRequest, SaveInPatientPackageResponse } from '../../../../shared/models/inPatient.model';
import { INVENTORY_FETCH_IP_PACKAGE, INVENTORY_SAVE_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import SendRequest from '../../../../shared/services/sendRequest.service';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { ReactComponent as EditIcon } from '../../../../assets/images/svg/i_edit.svg';

const DaycarePackageDetail = ({ match: { path, params: { id: packageId } } }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const [packageDetail, setPackageDetail] = useState(null as any);
  const [isChecked, setIsChecked] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const id = base64UrlDecode(packageId);
  const isAuthorized = canActivate(authFeatureConstants.EDIT_DAY_CARE_SERVICES);

  const inclusionMasterList = useSelector(
    ({ hospital: { dayCareinclusionMaster } }: any): any => dayCareinclusionMaster,
  );

  useEffect((): void => {
    if (!inclusionMasterList) {
      dispatch(fetchDayCareInclusionMaster());
    }
  }, []);

  useEffect((): void => {
    const reqpayload: FetchInPatientPackageRequest = {
      fetchInActiveRecord: true,
      pageNumber: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      packageById: true,
      ids: [+id],
      packageType: 'DayCare',
    };
    fetchPackageDetail(reqpayload);
  }, [id]);

  const fetchPackageDetail = async (
    payload: any,
  ): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_FETCH_IP_PACKAGE;
    const result: FetchInPatientPackageResponse = await SendRequest.instance.post<
      FetchInPatientPackageRequest,
      FetchInPatientPackageResponse
    >(url, payload);
    if (result && result.isSuccess && result.packages && result.packages.length > 0) {
      setPackageDetail(GetFirstElement(result.packages));
      setIsChecked(GetFirstElement(result.packages)?.isActive);
    } else {
      error('Please try again');
    }
  };
  const onEditProfile = (): void => {
    history.push(`${extractSecondLevelBaseUrl(path)}/edit-daycare-package/${base64UrlEncode(id)}
    ${PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}`);
  };

  const onDeletePackage = async (): Promise<void> => {
    const payload: SaveInPatientPackageRequest = {
      applicationId: APPLICATION_ID,
      package: {
        ...packageDetail, isActive: !packageDetail?.isActive, inclusionList: [], pricingList: [],
      },
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_IP_PACKAGE;
    const result: SaveInPatientPackageResponse = await SendRequest.instance.post<
      SaveInPatientPackageRequest,
      SaveInPatientPackageResponse
    >(url, payload);
    if (result && result.isSuccess) {
      if (isChecked) {
        success(INVENTORY_MESSAGE_CONSTANTS.isDeactivatedSuccess);
      } else {
        success(INVENTORY_MESSAGE_CONSTANTS.isActivatedSuccess);
      }
      setIsChecked(!isChecked);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.tryAgain);
    }
  };

  const CalculateDiscountPercentage = (price: number, discountedPrice: number): number => {
    if (price > 0) {
      return Math.round(((price - discountedPrice) / price) * 100);
    } else {
      return 0;
    }
  };
  let pricingList: any;
  if (packageDetail && packageDetail.pricingDetails && packageDetail.pricingDetails.length > 0) {
    pricingList = packageDetail.pricingDetails.map((pricing: any, index: number): any => {
      return (<Row gutter={GUTTOR_SPACE} key={pricing.id} className="mb-md">
        <Col md={2}>
          <p className="session-count" style={{ marginTop: 20 }}>{index + 1}</p>
        </Col>
        <Col md={6}>
          <p className="label-title">Price</p>
          <Form.Item className="mb-0">
            <Input type="text" value={formatPrice(pricing.price, false)} disabled={true} />
          </Form.Item>
        </Col>
        <Col md={4}>
          <p className="label-title">Discount</p>
          <Form.Item className="mb-0">
            <Input type="text" value={CalculateDiscountPercentage(pricing.price, pricing.discountedPrice)} disabled={true} suffix="%" />
          </Form.Item>
        </Col>
        <Col md={6}>
          <p className="label-title">Discounted price</p>
          <Form.Item className="mb-0">
            <Input type="text" value={formatPrice(pricing.discountedPrice, false)} disabled={true} />
          </Form.Item>
        </Col>
      </Row>);
    });
  }
  const getSelectedInclusion = (): string[] => {
    return packageDetail.inclusions ? packageDetail.inclusions
      .filter((x: any): boolean => x.isActive)
      .map((x: any): string => {
        return x.inclusionName;
      }) : null;
  };

  return (
    <>
      <PageHeader
        pageTitle={packageDetail?.procedureName}
        backUrl={extractSecondLevelBaseUrl(path) +
          INVENTROY_CONSTANTS.dayCarePackagesRoute + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        rightComponent={(): ReactElement =>
          <Row gutter={GUTTOR_SPACE}>
            <Col md={20} />
            <Col md={4} className="text-right">
              {
                isAuthorized &&
                <Tooltip placement={'bottom'} title={TOOLTIP_TEXT.edit}>
                  <Button type={'text'} onClick={onEditProfile} className="v-align-sub">
                    <EditIcon className="fill-primary" />
                  </Button>
                </Tooltip>
              }
              <Popconfirm placement={'topLeft'}
                disabled={!isAuthorized}
                title={!isChecked ? INVENTORY_MESSAGE_CONSTANTS.isActivatePackage : INVENTORY_MESSAGE_CONSTANTS.isDeActivatePackage}
                onConfirm={onDeletePackage}
                okText="Yes"
                cancelText="No"
              >
                <Tooltip placement={'bottom'} title={isChecked ? TOOLTIP_TEXT.active : TOOLTIP_TEXT.inActive}>
                  <Button type={'text'}>
                    <Switch size="small" checked={isChecked} disabled={!isAuthorized}/>
                  </Button>
                </Tooltip>
              </Popconfirm>
            </Col>
          </Row>}
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        {packageDetail &&
          <Row gutter={GUTTOR_SPACE}>
            <Col md={16}>
              <Panel
                title="Package Details"
              >
                <div className="label-value mb-0">
                  {packageDetail.procedureName}
                </div>
                <p className="text-elipsis"
                  style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: packageDetail?.description }} />
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={12}>
                    <p className="label-title">Department</p>
                    <div className="label-value mb-0">
                      {packageDetail.departmentName}
                    </div>
                  </Col>
                  <Col md={12}>
                    <p className="label-title">Procedure name</p>
                    <div className="label-value mb-0">{packageDetail.procedureName}</div>
                  </Col>
                </Row>
              </Panel>
              <Panel title="Pricing Details">{pricingList}</Panel>
            </Col>
            {inclusionMasterList &&
              <Col md={8}>
                <Panel title="Inclusions">
                  <Checkbox.Group
                    className="inclusion-checkbox"
                    options={getSelectedInclusion()}
                    value={getSelectedInclusion()}
                  />
                </Panel>
              </Col>}
          </Row>
        }
      </div>
    </>
  );
};

export default DaycarePackageDetail;
